// reducers/formReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  annualIncome: '',
  dob: '',
  firstName: '',
  lastName: '',
  gender: '',
  smoke: '',
  mobileNo: "",
  email: '',
  sbgGroup: '',
  state: '',
  downloadPath: "",
  count: 0,
  popupMessage: "",
  popupVisible: false,
  focusedField: null,
  lastInteractionTime: Date.now(),
  nextField: "",
  lastFieldIndex: -1,
  income1status: false,
  income2status: false,
  smoke1: false,
  smoke2: false,
  sbg1: false,
  sbg2: false,
  pageCondition: "1",
  callWidget:"",

};

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setCallWidget: (state, action) => {
      state.callWidget = action.payload
    },
    setPageCondition: (state, action) => {
      state.pageCondition = action.payload
    },
    setPageCondition: (state, action) => {
      state.pageCondition = action.payload
    },
    setIncome1Status: (state, action) => {
      state.income1status = action.payload
    },
    setIncome2Status: (state, action) => {
      state.income2status = action.payload
    },

    setSmoke1: (state, action) => {
      state.smoke1 = action.payload
    },

    setSmoke2: (state, action) => {
      state.smoke2 = action.payload
    },

    setSbg1: (state, action) => {
      state.sbg1 = action.payload
    },
    setSbg2: (state, action) => {
      state.sbg2 = action.payload
    },


    setLastInteractionTime: (state, action) => {
      state.lastInteractionTime = action.payload
    },

    setLastFieldIndex: (state, action) => {
      state.lastFieldIndex = action.payload
    },

    setNextField: (state, action) => {
      state.nextField = action.payload
    },
    setPopupMessage: (state, action) => {
      state.popupMessage = action.payload
    },

    setFocusedField: (state, action) => {
      state.focusedField = action.payload
    },

    setPopupVisible: (state, action) => {
      state.popupVisible = action.payload
    },

    setCount: (state, action) => {
      state.count = action.payload;
    },
    setDownloadPath: (state, action) => {
      state.downloadPath = action.payload;
    },
    updateAnnualIncome: (state, action) => {
      state.annualIncome = action.payload;
    },
    updateDOB: (state, action) => {
      state.dob = action.payload;
    },
    updateFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    updateLastName: (state, action) => {
      state.lastName = action.payload;
    },
    updateGender: (state, action) => {
      state.gender = action.payload;
    },
    updateSmoke: (state, action) => {
      state.smoke = action.payload;
    },
    updateMobileNo: (state, action) => {
      state.mobileNo = action.payload;
    },
    updateEmail: (state, action) => {
      state.email = action.payload;
    },
    updateSbgGroup: (state, action) => {
      state.sbgGroup = action.payload;
    },
    updateState: (state, action) => {
      state.state = action.payload;
    },
  }
});

export const {
  setCallWidget,
  setPageCondition,
  updateAnnualIncome,
  updateDOB,
  updateFirstName,
  updateLastName,
  updateGender,
  updateSmoke,
  updateMobileNo,
  updateEmail,
  updateSbgGroup,
  setDownloadPath,
  setCount,
  setFocusedField,
  setLastInteractionTime,
  setPopupMessage,
  setPopupVisible,
  focusedField,
  popupVisible,
  lastInteractionTime,
  lastFieldIndex,
  setLastFieldIndex,
  setNextField,
  nextField,
  setIncome1Status,
  setIncome2Status,
  setSmoke1,
  setSmoke2,
  smoke1,
  smoke2,
  sbg1,
  sbg2,
  setSbg1,
  setSbg2,

  updateState } = formSlice.actions;
export default formSlice.reducer;
